<template>
  <div>
    <b-card>
      <titleSection
        title="Modalidad"
        subtitle=""
        icon="MonitorIcon"
      />

      <div>
        <h5 class="text-primary mb-75 mt-2">
          <b>{{ modalidad.tipo || 'Espera la próxima edición' }}</b>
        </h5>
        <b-card-text>
          {{ modalidad.descripcion }}
        </b-card-text>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardText,
} from 'bootstrap-vue'
import titleSection from '@/views/components/title-section.vue'
import { getData } from '@core/utils/http/general'
import {
  ref, onMounted, watch,
} from '@vue/composition-api'

export default {
  components: {
    titleSection,
    BCard,
    BCardText,
  },
  props: {
    periodo: {
      type: [Number, null],
      default: null,
    },
  },
  setup(props) {
    const modalidad = ref({
      nombre: '',
      descripcion: '',
    })
    const modalidadF = () => {
      modalidad.value.nombre = ''
      modalidad.value.descripcion = ''
      getData({ action: 46, q: props.periodo })
        .then(response => {
          if (response.status === 200 && response.data.status === 200) {
            modalidad.value = response.data.modalidad
          }
        })
    }
    onMounted(() => {
      modalidadF()
    })
    watch(() => props.periodo, () => {
      modalidadF()
    })

    return {
      modalidad,
    }
  },
}
</script>
